
<div fxLayout="row" fxLayoutGap="10px" [formGroup]="grp">

  <app-time-period-select [formControl]="grp.controls.period" multiplyLabel="Every"></app-time-period-select>

  <mat-form-field>
    <mat-label>Base date</mat-label>
    <input matInput type="text" [matDatepicker]="baseDate" placeholder="" formControlName="baseDate" autocomplete="off">
    <mat-datepicker-toggle matSuffix [for]="baseDate"></mat-datepicker-toggle>
    <mat-datepicker #baseDate></mat-datepicker>
  </mat-form-field>
</div>